export var BACKOFFICE_CONFIG_PARAM = "name";
